type EventSubmit = React.FormEvent<HTMLFormElement>;
type HandleSubmit = (e: EventSubmit) => any;

export const makeHandleSubmit = <Handle extends HandleSubmit>(handle: Handle) => {
  return (e: EventSubmit) => {
    e?.preventDefault?.();
    return handle?.(e);
  };
};
